import tCentralenImg from './images/t-centralen-liggande.jpeg';
import stadionImg from './images/P7181756.jpg.optimal.jpg';
import solnaImg from './images/1562555.jpg';
import thorildsplanImg from './images/thorildsplan-liggande.jpeg';
import bagarmossenImg from './images/bagarmossen.jpg';
import kungstradgardenImg from './images/download.jpeg';

export default {
    items:[{
        "name": "T-Centralen",
        "line": "blue",
        "image": tCentralenImg,
        "description": "T-Centralen, the main hub of Stockholm’s subway, opened up for traffic in 1957 and was the first station to feature artwork. The blue line-platform, quite literally “the blue platform” is hands down one of the public transport system’s most recognizable places. But it didn’t open until 1975 when the blue line to Hjulsta was completed."
    },
    {
        "name": "Stadion",
        "line": "red",
        "image": stadionImg,
        "description": "Each year Östermalms IP serves as the main festival area for the Stockholm Pride festival. By coincidence, the nearby subway station, Stadion, happens to have a beautiful rainbow in vivid colors painted against the bright blue of the station's cave walls to welcome festival goers."
    },
    {
        "name": "Solna Centrum",
        "line": "blue",
        "image": solnaImg,
        "description": "The station of Solna Centrum opened with the first arm of the blue line in 1975. The bright green and red landscape - the green being the forest and the red an evening sun setting behind the treetops - is both timeless in its beauty, but also something that few other stations artwork is; political."
    },
    {
        "name": "Thorildsplan",
        "line": "green",
        "image": thorildsplanImg,
        "description": "Thorildsplan is one of only three street-level surface stations in downtown Stockholm. The station was built in 1952, but the pixelated artwork by Lars Arrhenius is a more recent addition. Arrhenius was commissioned to create new art in 2008, the caveat being that it had to be tile work. Otherwise, he had total creative freedom, but considering his background the material was a perfect fit."
    },
    {
        "name": "Bagarmossen",
        "line": "green",
        "image": bagarmossenImg,
        "description": "Bagarmossen’s old subway station is to date the first and only to have been closed down and taken out of service. Where it once was situated at surface-level there now are residential buildings."
    },
    {
        "name": "Kungsträdgården",
        "line": "blue",
        "image": kungstradgardenImg,
        "description": "One of Stockholm’s most stunning stations is unsurprisingly also one of its most photographed: Kungsträdgården. Located in the middle of downtown Stockholm, it’s the terminus of the blue line, or at least until its southward extension opens in 2025."
    }]
}